/**
 * @fileoverview POST handler for the "/:app_group_id/conversational/tool_definition" endpoint
 */
import { exhaustiveCheck } from "@lib/exhaustiveCheck";
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { conversationalToolDefinitionCacheKeys } from "./constants";
import type {
  ConversationalToolDefinitionResult,
  PostConversationalToolDefinitionErrors,
  PostConversationalToolDefinitionProps,
} from "./types";

const buildCreateParams = (props: PostConversationalToolDefinitionProps): Record<string, unknown> => {
  switch (props.type) {
    case "workflow_attribute":
      return {
        type: props.type,
        name: props.name,
        description: props.description,
        data_type: props.dataType,
        allowed_values: props.allowedValues,
      };
    default:
      exhaustiveCheck(props.type);
      return {};
  }
};

export const postConversationalToolDefinition = reactQueryMutationAdapter(
  conversationalToolDefinitionCacheKeys,
  createMutationFetcherFunctionWithShadowError<PostConversationalToolDefinitionErrors>()(
    (props: PostConversationalToolDefinitionProps): Promise<ConversationalToolDefinitionResult> => {
      return fetch(
        `/${props.appGroupId}/conversational/tool_definition`,
        "POST",
        buildCreateParams(props),
        undefined,
        {
          propagateFetchRequestError: false,
        }
      );
    }
  )
);
